<template>    
    <v-card>
        <!-- Titulo del dialogo -->
        <v-card-title>
            Crear Procedencia
        </v-card-title>
        <v-divider></v-divider>
            <!-- Formulario -->
        <v-form ref="form">
            <v-row class="py-3 px-6">
                <v-col cols="12" sm="6" md="4">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="producto.nombre" label="Nombre"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="producto.valor" type="number" label="Valor"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                    <v-select :rules="[v => !!v || 'Campo requerido']" v-model="producto.categoria" :items="categorias" label="Categoría"></v-select>
                </v-col>
                <v-col cols="12" sm="6" md="8">
                    <v-textarea :rules="[v => !!v || 'Campo requerido']" v-model="producto.descripcion" label="Descripción"></v-textarea>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                    <v-card-actions class="pt-4">
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text :disabled="!valid" @click="save">Guardar</v-btn>
                    </v-card-actions>
                </v-col>
            </v-row>
        </v-form>
    </v-card>
</template>

<script>
import axios from "axios";
export default {
    props:{
        producto:Object
    },
    data:()=>({  
        valid: true,
        rules: {
            required: value => !!value || 'Campo requerido',
        },
    }),
    computed:{
        categorias(){
            return [
                'complementos', 
                'bebidas', 
                'comida'
            ]
        }
    },
    methods:{
        close () {
            this.$nextTick(() => {
                this.$emit("closeDialogEditProducto", false);
            })
        },
        save () {
            axios.put("https://torstdio.site/api/v1/producto/actualizar",Object.assign(this.producto)).then(response=>{
                this.close()
            })
            
        },
    }
}
</script>


